export enum GroupStatus {
    PRIVATE = "PRIVATE",
    PUBLIC = "PUBLIC",
    ALL_GROUP_STATUSES = "ALL_GROUP_STATUSES",
    DRAFT = "DRAFT",
    ARCHIVED = "ARCHIVED",
}
